module.exports = __webpack_public_path__ + "img/Swiss.ffab8e12.svg";